var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    viewBox: "0 0 9 14",
    width: 9,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.89844 6.74219c-.00782-.35938-.13282-.64844-.42969-.9375l-5.60156-5.476565c-.21875-.21875-.47657-.328125-.79688-.328125-.64062 0-1.156248.515625-1.156248 1.14844 0 .3125.124998.60937.367188.84375l4.89844 4.74219-4.89844 4.75782c-.23437.2344-.367188.5234-.367188.8437 0 .6329.515628 1.1485 1.156248 1.1485.3125 0 .57813-.1016.79688-.3282l5.60156-5.47651c.29687-.28907.42969-.58594.42969-.9375z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/right.de79849209a4edc58be56688d0d4d95b.svg";